export default "/_next/static/images/magic-line-sparkle-left-b244c6667bc5d2f4b6cb403db5b557f6.svg";